import { styled } from "@mui/material/styles";

const StyledLinkExpired = styled("div")(
  ({ theme }) => `
  .linkexpired-wrap {
  width: 27%;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}
.spam-folder-text {
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;
}
.spam-folder-text span {
  color: ${theme.palette.primary.main};
}
.button-wrap {
  display: flex;
  flex-direction: column;
  gap: 20px;
}  

.body-wrap {
  display: flex;
   flex-direction: column;
   gap: 20px;
}
.header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 30px;
}
.linkexpired-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}    

.body-text {
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}

.linkexpired-header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: normal;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }  
}
.linkexpired-sub-header{
  margin-top: 12px;
  margin-bottom: 32px;
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
    @media screen and (max-width: 480px) {
    font-size: 14px;
  }  
}

.circleIcon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(238, 217, 199, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.backLogin {
  text-align: center;
  margin-top: 20px;
}
.backLogin a {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  text-decoration: underline
}
  
.submit-btn {
  width: 100%;
  padding: 10px;
  fontSize: 16px;
  textTransform: none;
}
`
);

export default StyledLinkExpired;
